import { type Entity, widget } from '../entities';
import type { TrackingContextValue } from '../providers/TrackingContext';

const widgetEntityExists = (entities: Entity[] = [], widgetEntity: Entity) =>
  entities.find(({ schema }) => schema === widgetEntity.schema);

export const getEntities = (context: Omit<TrackingContextValue, 'category'> = {}) => {
  const entities: Entity[] = [];

  if (context.widget) {
    const widgetEntity = widget(context.widget);
    if (!widgetEntityExists(context.entities, widgetEntity)) {
      entities.push(widgetEntity);
    }
  }

  context.entities && entities.push(...context.entities);
  return entities;
};
